/* tslint:disable */
/* eslint-disable */
/**
 * Properties API
 * API for managing properties
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SearchParcBiensCommand
 */
export interface SearchParcBiensCommand {
    /**
     * Recherche par nom ou adresse
     * @type {string}
     * @memberof SearchParcBiensCommand
     */
    searchString?: string;
    /**
     * 
     * @type {number}
     * @memberof SearchParcBiensCommand
     */
    pageNumber: number;
    /**
     * 
     * @type {number}
     * @memberof SearchParcBiensCommand
     */
    pageSize: number;
    /**
     * Filtre optionnel par type de bien (valeur de TypeBienImmobilierEnum)
     * @type {number}
     * @memberof SearchParcBiensCommand
     */
    propertyType?: number | null;
}

/**
 * Check if a given object implements the SearchParcBiensCommand interface.
 */
export function instanceOfSearchParcBiensCommand(value: object): value is SearchParcBiensCommand {
    if (!('pageNumber' in value) || value['pageNumber'] === undefined) return false;
    if (!('pageSize' in value) || value['pageSize'] === undefined) return false;
    return true;
}

export function SearchParcBiensCommandFromJSON(json: any): SearchParcBiensCommand {
    return SearchParcBiensCommandFromJSONTyped(json, false);
}

export function SearchParcBiensCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchParcBiensCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'searchString': json['searchString'] == null ? undefined : json['searchString'],
        'pageNumber': json['pageNumber'],
        'pageSize': json['pageSize'],
        'propertyType': json['propertyType'] == null ? undefined : json['propertyType'],
    };
}

export function SearchParcBiensCommandToJSON(json: any): SearchParcBiensCommand {
    return SearchParcBiensCommandToJSONTyped(json, false);
}

export function SearchParcBiensCommandToJSONTyped(value?: SearchParcBiensCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'searchString': value['searchString'],
        'pageNumber': value['pageNumber'],
        'pageSize': value['pageSize'],
        'propertyType': value['propertyType'],
    };
}

